import React, { useState } from "react";
import { Label, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HandleMoveStudentsToClass } from "../../actions/teacherMutations";
import Select from "react-select";

const MoveStudentsToClassForm = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [validationError, setValidationError] = useState(null);
  const mutateMoveStudents = useMutation({ mutationFn: HandleMoveStudentsToClass });
  const queryClient = useQueryClient();

  const handleChange = (selected) => {
    let studentsToAdd = [];
    selected.forEach((selectedStud) => {
      studentsToAdd.push(selectedStud.id);
    });
    setValidationError(null);
    setSelectedStudentIds(studentsToAdd);
  };

  const handleSubmit = async () => {
    if (selectedStudentIds.length < 1) {
      setValidationError(<FormattedMessage id="YouHaveToSelectOneStudent" />);
    } else {
      setValidationError(null);
      setIsSubmitting(true);

      await mutateMoveStudents.mutateAsync(
        {
          selectedStudentIds: selectedStudentIds,
          classId: props.classId,
        },
        {
          onSuccess: (data) => {
            if (data && data.status > 199 && data.status < 300) {
              toast.success(<FormattedMessage id="StudentsMoved" />);
              queryClient.invalidateQueries({ queryKey: ["FetchTeacherInformation"] });
              queryClient.invalidateQueries({ queryKey: ["FetchClassByClassId", props.classId] });
            } else {
              toast.warn(data);
            }
          },
          throwOnError: true,
          onError: (data) => {
            toast.warn(data);
          },
        }
      );
      setIsSubmitting(false);
      props.dismissModal();
    }
  };

  const getFilteredStudents = () => {
    var students = [];
    props.students.forEach((s) => {
      if (props.existingStudents.findIndex((es) => es.id === s.id) === -1) {
        students.push(s);
      }
    });
    return students;
  };

  return (
    <div className="col-12 col-sm-12">
      <Label>
        <FormattedMessage id="ChooseOneOrMoreStudents" />
      </Label>
      <Select
        isMulti
        onChange={(selected) => handleChange(selected)}
        options={getFilteredStudents().map((option) => ({
          ...option,
          label: option.name,
          value: option.id,
          clearableValue: true,
        }))}
      />
      <span className="text-warning">{validationError}</span>
      <div className="d-flex justify-content-end gap-2 btn-container">
        <Button
          color="secondary"
          outline
          type="button"
          onClick={props.dismissModal}
        >
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          color="primary"
          outline
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <FormattedMessage id="Wait" />
          ) : (
            <FormattedMessage id="Add" />
          )}
        </Button>
      </div>
    </div>
  );
};

export default MoveStudentsToClassForm;
